import { realSchoolId, useAuthStore } from "@/store/auth-store";

const MULTI_SCHOOL_ROLES = new Set(["CHAIRMAN", "DIRECTOR"]);

/**
 * A notification belongs to one school. A multi-school overseer (chairman /
 * director) tapping it while on "All schools" (or on another campus) used to
 * land on the consolidated "pick a school" hub for that route instead of the
 * item — the route needs a school and none was chosen. Scope to the
 * notification's school first, but only when it is one of the overseer's own
 * schools; everyone else (single-school roles) is untouched.
 */
export function scopeToNotificationSchool(schoolId: string | null | undefined): void {
  if (!schoolId) return;
  const { user, activeSchoolId, setActiveSchool } = useAuthStore.getState();
  if (!user || !MULTI_SCHOOL_ROLES.has(user.role)) return;
  if (realSchoolId(activeSchoolId) === schoolId) return;
  if (!(user.schools ?? []).some((s) => s.id === schoolId)) return;
  setActiveSchool(schoolId);
}
